/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'

const useAutocomplete = (employeeInfo) => {
    const [valueState, setValueState] = useState();
    const [inputValueState, setInputValueState] = useState('');
    const [valueCounty, setValueCounty] = useState();
    const [inputValueCounty, setInputValueCounty] = useState('');
    const [valueCity, setValueCity] = useState();
    const [inputValueCity, setInputValueCity] = useState('');

    useEffect(() => {
        setValueState(employeeInfo?.state ?? '');
        setInputValueState(employeeInfo?.state ?? '');
        setValueCounty(employeeInfo?.county ?? '');
        setInputValueCounty(employeeInfo?.county ?? '');
        setValueCity(employeeInfo?.city ?? '');
        setInputValueCity(employeeInfo?.city ?? '');
    }, [employeeInfo?.id]);
    
  return {
    valueState,
    inputValueState,
    valueCounty,
    inputValueCounty,
    valueCity,
    inputValueCity,
    setValueState,
    setInputValueState,
    setValueCounty,
    setInputValueCounty,
    setInputValueCity,
    setValueCity
  }
}

export default useAutocomplete